module.exports = __webpack_public_path__ + "img/sk-partners-teraz.5cda7585.png";